import React, {useEffect, useState} from 'react';
import {getNQuizByProduct} from "../../services/TestRepository";

import {SimpleGrid} from "../SimpleGrid";
import {useOutletContext} from "react-router-dom";
import {QuizThumbnail} from "../quiz/QuizThumbnail";

export function QuizPanel() {

    const [quizzes, setQuizzes] = useState([]);
    const {product} = useOutletContext();

    useEffect(() => {
        if (product != null) {
            getNQuizByProduct(40).then(result => {
                if (result != null) {
                    setQuizzes(result);
                }
            }).catch(e => console.log(e))
        }
    }, [product]);

    return (

        <div className={" "}>
            <div className={"row m-0 align-items-center justify-content-center p-0"}>
                {
                    quizzes.map(quiz => (
                        <div
                            className={"d-flex flex-column rounded me-3 mb-4 col-lg-4 col-sm-2 p-0"}>
                            <QuizThumbnail name={quiz.test.name} questionCount={quiz.test.questionCount} highscore={quiz.highscore}/>
                        </div>
                    ))
                }
            </div>

        </div>

    );


}